import { PrimitiveValueObject } from './primitiveValueObject';

/**
 * 単一項目のValueObject.
 */
export abstract class PrimitiveValueObjectDate extends PrimitiveValueObject<Date> {
  /**
   * 日時にする
   * @param date 日時
   * @returns yyyy-MM-dd
   */
  static toStringDate(date: Date) {
    const y = date.getFullYear();
    const m = (`00${date.getMonth() + 1}`).slice(-2);
    const d = (`00${date.getDate()}`).slice(-2);
    return `${y}-${m}-${d}`;
  }

  /**
   * 表示用日時にする
   * @param date 日時
   * @returns yyyy年MM月dd日(Week)
   */
  static toStringDateDisplay(date: Date) {
    const y = date.getFullYear();
    const mon = (`00${date.getMonth() + 1}`).slice(-2);
    const d = (`00${date.getDate()}`).slice(-2);
    const week = ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
    return `${y}年${mon}月${d}日(${week})`;
  }

  /**
   * 日時文字にする
   * @returns 文字
   */
  toStringDate() {
    return PrimitiveValueObjectDate.toStringDate(this.value);
  }

  /**
   * 日時文字表示用を取得する
   * @returns 文字
   */
  toStringDateDisplay() {
    return PrimitiveValueObjectDate.toStringDateDisplay(this.value);
  }
}
